<template>
  <img
    :src="field.url"
    :alt="field.alt"
    :copyright="field.copyright"
    class="image"
  />
</template>

<script>
export default {
  name: 'PrismicImage',
  props: {
    field: {
      type: Object,
      required: true,
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/base/colors';

img {
  max-width: 100%;
}

.magenta {
  background-color: $magenta;
}
.purple {
  background-color: $purple;
}
.dark-blue {
  background-color: $dark-blue;
}
.orange {
  background-color: $orange;
}
.red {
  background-color: $red;
}
.brown {
  background-color: $brown;
}
.dark-green {
  background-color: $dark-green;
}
.green {
  background-color: $green;
}
</style>
